<c-card *transloco="let t">
    <c-card-body class="px-2" *ngIf="account">
  
      <c-row>
        <c-col class="col-lg-6 col-12">
          <h1>{{ t('Safety Monitoring Center Scheduling') }}</h1>
          <p>{{ t('Ensure your team is covered during out-of-hours or when monitors are unavailable to respond immediately. With our scheduling tool, you can designate the Safety Monitoring Center as the first point of contact, letting our trained operators handle alerts and escalate as needed. Stay confident knowing your team is supported, anytime.') }}</p>
        </c-col>
      </c-row>

      <c-row>
        
        <ng-container *ngIf="account.arc_on">
          <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">
            <div class="row mb-3">
              <div class="col-6">
                <b>{{ t('Enable/Disable Scheduling') }}</b>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3">
                <select class="form-control" id="arc_schedule" name="arc_schedule" formControlName="arc_schedule">
                  <option [ngValue]="false">{{ t('Scheduling Disabled') }}</option>
                  <option [ngValue]="true">{{ t('Scheduling Enabled') }}</option>
                </select>
              </div>
              <div class="col-sm-3">
                <button cButton class="px-4 text-white btn-info" type="submit">
                  <i class="fa-solid fa-check"></i> {{ t('Save Scheduling') }}
                </button>
              </div>
            </div>
          </form>
        </ng-container>

      </c-row>

      <c-row *ngIf="account.arc_schedule == 1">
        <c-col md="12">
  
  
          <h1>{{ t('Schedule the SMC') }}</h1>
    
          <div class="row">
            <div class="col">
              <p><i class="fa-solid fa-circle-info text-info"></i> {{ t('Click on a day or time to edit the') }} <span class="badge bg-success text-white">{{ t('Start') }}</span>/<span class="badge bg-warning text-white">{{ t('End') }}</span> {{ t('times for that day:') }}</p>
            </div>
            <div class="col text-end">
              <button type="button" class="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#batchModal">
                <i class="fa-solid fa-user-clock"></i> {{ t('Add Multiple Start/End Times') }}
              </button>
            </div>
          </div>


          <!-- Day Modal -->
          <div class="modal fade" id="editDayModal" tabindex="-1" aria-labelledby="editDayModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="editLoopModalLabel">{{ t('Times for') }} {{edit_day_str}}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  
                    <form *ngIf="dayGroup" [formGroup]="dayGroup" cForm (ngSubmit)="submitDayForm()">

                        <div class="form-group row mb-2" >
                          <label class="col-sm-4 col-form-label text-end"> {{ t('Start Time') }}</label>
                          <div class="col-sm-8">
                            <ng-select [items]="day_hours"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="start">
                          </ng-select>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-sm-4 col-form-label text-end"> {{ t('End Time') }}</label>
                          <div class="col-sm-8">
                            <ng-select [items]="day_hours"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="end">
                          </ng-select>
                          </div>
                        </div>

                        <div class="alert alert-warning" role="alert" *ngIf="this.alert_message">
                          {{this.alert_message}}
                        </div>

                      <button cButton class="px-4 text-white btn-info" type="submit">
                        <i class="fa-solid fa-check"></i> {{ t('Update Start/End Times') }}
                      </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

    
          <full-calendar [deepChangeDetection]="deepChangeDetection" [options]="calendarOptions"></full-calendar>


          <!-- Batch Modal -->
          <div class="modal fade" id="batchModal" tabindex="-1" aria-labelledby="batchModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="batchModalLabel">{{ t('Add Multiple Start/End Times') }}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" *ngIf="batchGroup">
                  <p>{{ t('Use this form to set start and end times. You can choose the start and end date, and the days of the week to apply the start times too. To remove start times choose Remove.') }}</p>

                    <div class="row mb- row mb-2">
                      <label class="col-sm-4 col-form-label text-end">{{ t('Dates') }}</label>
                      <div class="col-sm-8">
                          <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="batch_dates" name="dates"  class="form-control"/>
                      </div>
                    </div>
                    <form [formGroup]="batchGroup" cForm>

                    <div class="form-group row mb-2" >
                      <label class="col-sm-4 col-form-label text-end"> {{ t('Start Time') }}</label>
                      <div class="col-sm-8">
                        <ng-select [items]="batch_times"
                        bindLabel="name"
                        bindValue="value"
                        formControlName="start_time">
                      </ng-select>
                      </div>
                    </div>

                    <div class="form-group row mb-2" >
                      <label class="col-sm-4 col-form-label text-end"> {{ t('End Time') }}</label>
                      <div class="col-sm-8">
                        <ng-select [items]="batch_times"
                        bindLabel="name"
                        bindValue="value"
                        formControlName="end_time">
                      </ng-select>
                      </div>
                    </div>

                    <div class="row mb-1">
                      <div class="col">
                        <input type="checkbox" class="form-check-input" formControlName="mon" name="mon"  id="mon">
                        <label class="form-check-label" for="mon">&nbsp;{{ t('Monday') }}</label>
                      </div>
                      <div class="col">
                        <input type="checkbox" class="form-check-input" formControlName="tue" name="tue"  id="tue">
                        <label class="form-check-label" for="tue">&nbsp;{{ t('Tuesday') }}</label>
                      </div>
                    </div>

                    <div class="row mb-1">
                      <div class="col">
                        <input type="checkbox" class="form-check-input" formControlName="wed" name="wed"  id="wed">
                        <label class="form-check-label" for="wed">&nbsp;{{ t('Wednesday') }}</label>
                      </div>
                      <div class="col">
                        <input type="checkbox" class="form-check-input" formControlName="thu" name="thu"  id="thu">
                        <label class="form-check-label" for="thu">&nbsp;{{ t('Thursday') }}</label>
                      </div>
                    </div>

                    <div class="row mb-1">
                      <div class="col">
                        <input type="checkbox" class="form-check-input" formControlName="fri" name="fri"  id="fri">
                        <label class="form-check-label" for="fri">&nbsp;{{ t('Friday') }}</label>
                      </div>
                    </div>

                    <div class="row mb-1">
                      <div class="col">
                        <input type="checkbox" class="form-check-input" formControlName="sat" name="sat" id="sat">
                        <label class="form-check-label" for="sat">&nbsp;{{ t('Saturday') }}</label>
                      </div>
                      <div class="col">
                        <input type="checkbox" class="form-check-input" formControlName="sun" name="sun" id="sun">
                        <label class="form-check-label" for="sun">&nbsp;{{ t('Sunday') }}</label>
                      </div>
                    </div>

                    <div class="alert alert-warning" role="alert" *ngIf="this.alert_message">
                      {{this.alert_message}}
                    </div>

                    <c-row>
                      <c-col class="mb-3 mt-2">
                        <button cButton class="text-white btn-info" type="submit" (click)="batchUpdate()" [disabled]="batch_loading">
                          <div *ngIf="!batch_loading"><i class="fa-solid fa-check"></i> {{ t('Update Start/End Times') }}  </div>
                          <div *ngIf="batch_loading"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Update Start/End Times') }}   </div>
                        </button>
                      </c-col>
                    </c-row>


                  </form>
                </div>
              </div>
            </div>
          </div>
        </c-col>
      </c-row>  
  </c-card-body>
</c-card>
  